import React from "react";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import PlaceOutlinedIcon from "@material-ui/icons/PlaceOutlined";
import WhatsAppIcon from "@material-ui/icons/WhatsApp";

import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import { APP_STRINGS } from "constants/appStrings";

const useStyles = makeStyles((theme) => ({
  section: {
    width: "min(1240px, calc(100% - 48px))",
    margin: "0 auto",
    padding: theme.spacing(6, 0, 2),
    [theme.breakpoints.down("sm")]: {
      width: "min(100% - 32px, 1240px)",
    },
  },
  officeCard: {
    height: "100%",
    padding: theme.spacing(4),
    borderRadius: 34,
    background: "linear-gradient(135deg, #6d3d4d 0%, #8c5366 100%)",
    color: "#f7f2ea",
    boxShadow: "0 34px 70px rgba(98, 54, 69, 0.16)",
  },
  badge: {
    display: "inline-flex",
    padding: theme.spacing(1, 2),
    borderRadius: 999,
    background: "rgba(255,255,255,0.08)",
    color: "#e8d3ae",
    fontSize: 12,
    fontWeight: 700,
    letterSpacing: "0.12em",
    textTransform: "uppercase",
  },
  title: {
    margin: theme.spacing(2, 0),
    fontFamily: '"Cormorant Garamond", "Times New Roman", serif',
    fontSize: "clamp(2.5rem, 4vw, 3.9rem)",
    lineHeight: 0.96,
    color: "#fff7ed",
  },
  text: {
    fontSize: 17,
    lineHeight: 1.9,
    color: "rgba(247, 242, 234, 0.78)",
  },
  detailBox: {
    marginTop: theme.spacing(3),
    padding: theme.spacing(2.5),
    borderRadius: 24,
    background: "rgba(255,255,255,0.06)",
    border: "1px solid rgba(255,255,255,0.1)",
  },
  detailTitle: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
    color: "#fff2dc",
    fontWeight: 700,
    marginBottom: theme.spacing(1),
  },
  detailText: {
    color: "rgba(247, 242, 234, 0.76)",
    lineHeight: 1.8,
  },
  ctas: {
    display: "flex",
    gap: theme.spacing(2),
    flexWrap: "wrap",
    marginTop: theme.spacing(4),
  },
  primaryButton: {
    minHeight: 54,
    padding: theme.spacing(0, 3),
    borderRadius: 999,
    background: "linear-gradient(135deg, #d1b07a 0%, #c39b63 100%)",
    color: "#5b3240",
    fontWeight: 700,
  },
  secondaryButton: {
    minHeight: 54,
    padding: theme.spacing(0, 3),
    borderRadius: 999,
    border: "1px solid rgba(255,255,255,0.18)",
    color: "#fff7ed",
  },
  mapWrap: {
    height: "100%",
    minHeight: 560,
    borderRadius: 34,
    overflow: "hidden",
    border: "1px solid rgba(31, 38, 50, 0.08)",
    boxShadow: "0 30px 70px rgba(22, 29, 40, 0.1)",
    background: "#ddd",
    [theme.breakpoints.down("sm")]: {
      minHeight: 420,
    },
  },
  map: {
    width: "100%",
    height: "100%",
    border: 0,
  },
}));

export default function LocationSection({ rollPageOnClickButton }) {
  const classes = useStyles();

  return (
    <div className={classes.section}>
      <GridContainer spacing={4}>
        <GridItem xs={12} md={5}>
          <div className={classes.officeCard}>
            <span className={classes.badge}>{APP_STRINGS.location.badge}</span>
            <Typography component="h2" className={classes.title}>
              {APP_STRINGS.location.title}
            </Typography>
            <Typography component="p" className={classes.text}>
              {APP_STRINGS.location.text}
            </Typography>

            <div className={classes.detailBox}>
              <div className={classes.detailTitle}>
                <PlaceOutlinedIcon fontSize="small" />
                {APP_STRINGS.location.detailTitle}
              </div>
              <div className={classes.detailText}>
                {APP_STRINGS.location.detailText}
              </div>
            </div>

            <Box className={classes.ctas}>
              <Button
                className={classes.primaryButton}
                onClick={() => rollPageOnClickButton("contact")}
              >
                {APP_STRINGS.location.primaryCta}
              </Button>
              <Button
                className={classes.secondaryButton}
                startIcon={<WhatsAppIcon />}
                href={APP_STRINGS.links.whatsappSchedule}
                target="_blank"
                rel="noreferrer"
              >
                {APP_STRINGS.location.secondaryCta}
              </Button>
            </Box>
          </div>
        </GridItem>

        <GridItem xs={12} md={7}>
          <div className={classes.mapWrap}>
            <iframe
              title={APP_STRINGS.location.mapTitle}
              className={classes.map}
              src="https://maps.google.com/maps?ll=-26.3031788,-48.8533809&q=-26.3031788,-48.8533809%20(Ana%20Carolina%20Lucena%20-%20Advocacia%20e%20Assessoria)&z=17&output=embed"
              allowFullScreen=""
              aria-hidden="false"
              tabIndex="0"
            />
          </div>
        </GridItem>
      </GridContainer>
    </div>
  );
}
